export function IconUsersTeam() {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 20V18.3333C19 17.4493 18.6576 16.6014 18.0481 15.9763C17.4386 15.3512 16.612 15 15.75 15H9.25C8.38805 15 7.5614 15.3512 6.9519 15.9763C6.34241 16.6014 6 17.4493 6 18.3333V20M1 19V17.5454C1 16.7738 1.30102 16.0338 1.83684 15.4882C2.2008 15.1176 2.65284 14.8573 3.14286 14.7285M6 6C4.76769 6.32296 3.85714 7.46201 3.85714 8.8176C3.85714 10.1732 4.76769 11.3122 6 11.6352M23 19V17.5454C23 16.7738 22.699 16.0338 22.1632 15.4882C21.7992 15.1176 21.3472 14.8573 20.8571 14.7285M18 6C19.2323 6.32296 20.1429 7.46201 20.1429 8.8176C20.1429 10.1732 19.2323 11.3122 18 11.6352M15.75 8.33333C15.75 10.1743 14.2949 11.6667 12.5 11.6667C10.7051 11.6667 9.25 10.1743 9.25 8.33333C9.25 6.49238 10.7051 5 12.5 5C14.2949 5 15.75 6.49238 15.75 8.33333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        vectorEffect="non-scaling-size"
      />
    </svg>
  );
}
